import { PutSupplierHearingCapacityListReq, SupplierMaxCapacity } from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class PutHearingCapacityGateway {
  /** 業者ヒアリング(労務能力)-明細登録 */
  static putSupplierHearingCapacityList = async (
    params: { data: PutSupplierHearingCapacityListReq }
  ) => {
    // 対応可能エリアが空文字またはundefinedの場合、nullに置き換える
    const tempWorkQuantityList = params.data.workCapacityList.map(v => {
      let tempRemark = v.remark
      if (v.remark === '' || v.remark === undefined) {
        tempRemark = null
      }

      const tempObj: SupplierMaxCapacity = {
        ...v,
        remark: tempRemark
      }

      return tempObj
    })
    const param = {
      data: {
        ...params.data,
        workQuantityList: tempWorkQuantityList
      }
    }
    return await yamadumiApi.put<PutSupplierHearingCapacityListReq>(
      '/api/supplier/hearing/capacity/list',
      param
    )
  }
}
